jQuery(document).ready(function() {

	//Accordion trigger in Footer
  jQuery(document).on( 'click', '.site-footer .site-footer__accordion-button', function(e){
    e.preventDefault();
    var itemThis = jQuery(this).parent().parent().parent();
    jQuery(itemThis).toggleClass('active');
  });
  
  //Sticky header logic
	var stickyLastScrollTop = 0;
	var stickyHeaderElementHeight = jQuery('.site-top__wrapper').outerHeight();
	var stickyHeaderElementPosition = stickyHeaderElementHeight*-1;

	function isIE() {
	  ua = navigator.userAgent;
	  var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
	  
	  return is_ie; 
	}
	if (isIE()){
		jQuery('#PageContainer').css({'margin-top': jQuery('#shopify-section-header').outerHeight() +'px'});
	}

	var checkHeader = function(){ 
		var st = window.pageYOffset || document.documentElement.scrollTop;
	  
		if (st > stickyLastScrollTop && window.pageYOffset > stickyHeaderElementHeight){
	    jQuery('#shopify-section-header').addClass('sticky-down');
	    jQuery('body').addClass('sticky-down');
	    jQuery('#shopify-section-header').removeClass('sticky-up');
	    jQuery('body').removeClass('sticky-up');
	    jQuery('#shopify-section-header').css({'top': stickyHeaderElementPosition +'px'});
	  } else {
			jQuery('#shopify-section-header').addClass('sticky-up');
			jQuery('body').addClass('sticky-up');
	    jQuery('#shopify-section-header').removeClass('sticky-down');
	    jQuery('body').removeClass('sticky-down');
	    jQuery('#shopify-section-header').css({'top': '0'});
	  }

    stickyLastScrollTop = st < 0 ? 0 : st;
	};

	// Run the checkHeader function every time you scroll
	window.addEventListener('scroll', checkHeader);

	//Bundle label swap
  function productBundleHoverText() {
  	let swapLabel = jQuery( '.product__bundleset .select-heading span' );
    let selectedText = swapLabel.text();

    jQuery('.product__bundleset li a').hover(function(){
      let hoverText = $(this).find('.product__bundleset-title').text();
      swapLabel.text(hoverText);
    }, function() {
      swapLabel.text(selectedText);
    });
  }

	function productSwatchHoverText() {
    let swapSwatch = jQuery( '.product__swatch .select-heading span' );
    let selectedSwatch = swapSwatch.text();

    jQuery('.product__swatch li a').hover(function(){
      let hoverSwatch = $(this).find('img').attr('alt');
      swapSwatch.text(hoverSwatch);
    }, function() {
      swapSwatch.text(selectedSwatch);
    });
  }

  //Functions for gift card check balance page
  if (jQuery('body').hasClass('full-template-page-gift-card-balance')){
  	giftCardsFAQ();
  	giftCardsTogglePassword();
  	giftCardsShowPin("block");
  };

  //Function for standalone FAQ for gift card
  if (jQuery('body').hasClass('full-template-page-faq-gift-card')){
  	giftCardsFAQ();
  };

  //Functions for product gift card
  if (jQuery('body').hasClass('template-product')){
    productBundleHoverText();
		productSwatchHoverText();
    pdpMediaSlider();
    charCount();
    pdpFeefoStars();
		pdpFeefoSroll();
    pdpTabToAccordion();
    worthPriceToolTip();
    pdpStoreLocatorDrawerAddItem();

    if (jQuery('body').hasClass('full-template-product-giftcards')){
    	giftCardsFAQ();
    	giftCardsStep2UndoRadio();
    	giftCardsStep2UndoInput();
    	giftCardsTextareaCount();
    	giftCardsTogglePassword();
    	//Product gift cards scroll to buy
    	jQuery('#scroll-buy').bind('click', {targetID:'#section-steps', dir:'down'}, giftCardsScroll);
    	//Product gift cards scroll to balance
    	jQuery('#scroll-balance').bind('click', {targetID:'#section-check-balance', dir:'down'}, giftCardsScroll);
    	//Product gift cards scroll to balance
    	//jQuery('#scroll-faq').bind('click', {targetID:'#section-faq', dir:'up'}, giftCardsScroll);
    	giftCardsShowPin("inline-flex");

		// Call gift card submission function
		giftCardHandler();
    }
  } else if( jQuery( '.giftcard-balance-check-page' ).length == 1 ) {
	giftCardPdpBalanceCheckForm();
	giftCardBalanceCheckDatalayer();
	} 

  //Product gifr cards toggle password input 
  function giftCardsTogglePassword() {
		jQuery(".toggle-password").click(function() {
			var input = jQuery("#balance-check-input-2");
			if (input.attr("type") == "password") {
				input.attr("type", "text");
			} else {
				input.attr("type", "password");
			}
		});
  }

  //Product gift cards count characters on textarea
  function giftCardsShowPin(style) {
  	jQuery("#balance-check-input-1").keyup(function() {
  		showPin('balance-check-input-1','#pin-field');

			function showPin(entrance,exit) {  
				var entranceObj = document.getElementById(entrance);  
				if(entranceObj.value.length == 16) {  
					jQuery(exit).css("display",style);
					jQuery( ".g-recaptcha" ).prop("disabled", false).css("height", "auto").css("visibility", "visible");
				} else {
					jQuery(exit).hide();
					jQuery( ".g-recaptcha" ).prop("disabled", true).css("height", "0px").css("visibility", "hidden");
				}
			}
		});
  }

  //Product gift cards count characters on textarea
  function giftCardsTextareaCount() {
  	jQuery("#message").on("input", function() {
  		var str = jQuery(this).val();
			str = str.replace(/((\ud83c[\udde6-\uddff]){2}|([\#\*0-9]\u20e3)|(\u00a9|\u00ae|[\u2000-\u3300]|[\ud83c-\ud83e][\ud000-\udfff])((\ud83c[\udffb-\udfff])?(\ud83e[\uddb0-\uddb3])?(\ufe0f?\u200d([\u2000-\u3300]|[\ud83c-\ud83e][\ud000-\udfff])\ufe0f?)?)*)/g, '');
			jQuery(this).val(str);

  		toCount('message','gift-cards-count','{CHAR}',500);

			function toCount(entrance,exit,text,characters) {  
				var entranceObj = document.getElementById(entrance);  
				var exitObj = document.getElementById(exit);  
				var length = characters - entranceObj.value.length;  
				if(length <= 0) {  
					length = 0;  
					text = '<span class="disable"> '+text+' <\/span>';  
					entranceObj.value = entranceObj.value.substr(0,characters);  
				}  
				exitObj.innerHTML = text.replace("{CHAR}",length);  
			}
		});
  }

  //Product gift cards FAQ
  function giftCardsFAQ() {
		jQuery(".accordion-faq").find(".accordion-toggle").click(function () {
			var isActive = jQuery(this).hasClass("active");
			jQuery(".accordion-toggle").removeClass("active");
			if (!isActive) {
				jQuery(this).toggleClass("active");
			}
			jQuery(this).next().slideToggle("fast");
			jQuery(".accordion-content").not(jQuery(this).next()).slideUp("fast");
		});
  }

  //Product gift cards click on other amount unchecked radio group
  function giftCardsStep2UndoRadio() {
  	jQuery("#amount-custom").focus(function(){
  		jQuery("input:radio[name=amount-group]").each(function () { jQuery(this).prop("checked", false); });
  	});
  }

  //Product gift cards checked on radio group remove other amount input
  function giftCardsStep2UndoInput() {
  	jQuery("input:radio[name=amount-group]").each(function () {
  		jQuery(this).click(function(){
  			jQuery("#amount-custom").val('');
  			jQuery("#amount-custom").removeClass('input--error');
  			jQuery("#amount-custom-error").remove();
  		});
  	});
  }

  //Product gift cards scroll to faq
  function giftCardsScroll(e) {
		e.preventDefault();
		var scrollPos = jQuery(e.data.targetID);
		if(e.data.dir == "down") {
			var stickyHeaderTopElementHeight = jQuery('.site-top__wrapper').outerHeight();
		} else {
			var stickyHeaderTopElementHeight = 0;
		}
		var stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight() - stickyHeaderTopElementHeight;

		jQuery('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'smooth');
  }

  //PDP media gallery
  function pdpMediaSlider() {
  	jQuery('.media-gallery-wrapper').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		  var i = (currentSlide ? currentSlide : 0) + 1;
		  jQuery('.media-gallery-nav .paging-info').text('image ' + i + '/' + slick.slideCount);
		  
		  if(jQuery('.media-gallery-wrapper .slick-current .js-zoom-enabled .zoomImg').length == 0) {
		  	enableZoom(jQuery('.media-gallery-wrapper .slick-current .js-zoom-enabled'));
		  }
		});

  	jQuery('.media-gallery-wrapper').slick({
  		lazyLoad: 'ondemand',
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: true,
		  fade: true,
		  infinite: true,
		  adaptiveHeight: true,
		  asNavFor: '.media-gallery-nav-wrapper'
		});

		function enableZoom(el) {
	    var zoomUrl = $(el).data('zoom');
	    jQuery(el).zoom({
	      url: zoomUrl,
	      on: 'click',
	      touch: true,
	      onZoomIn: function(){
	        jQuery(this).toggleClass("active");
	        jQuery(".media-gallery .zoom-badge").toggleClass("hide");
	      },
	      onZoomOut: function(){
	        jQuery(this).toggleClass("active");
	        jQuery(".media-gallery .zoom-badge").toggleClass("hide");
	      }
	    });
	  }

  	jQuery('.media-gallery-nav-wrapper').slick({
  		lazyLoad: 'ondemand',
			infinite: true,
		  slidesToShow: 5,
		  slidesToScroll: 1,
		  asNavFor: '.media-gallery-wrapper',
		  arrows: true,
		  dots: false,
		  swipeToSlide: true,
		  focusOnSelect: true,
			centerMode: true,
			accessibility: false
		});

		//Fix centerMode bug when items less than slidesToShow
		if(jQuery('.media-gallery-nav-wrapper .media-gallery-nav__thumbnails').length <= 5){
    	jQuery('.media-gallery-nav-wrapper').addClass('center-track');
		}

		if(!jQuery('.product-form__variants').length) {
      return;
    }

    var imageID = jQuery('.product-form__variants option:selected').attr("data-image-id");

    if(imageID) {
    	var slideIndex = jQuery('.media-gallery-wrapper').find('[data-image-id="' + imageID + '"]').parent().attr('data-slick-index');
    	jQuery('.media-gallery-wrapper').slick('slickGoTo', slideIndex, true);
  	}
  }

	// Run input char count for personisation input
	function charCount() {
		if(jQuery('.line-item-property__personalisation').length) {
			let max = jQuery('.line-item-property__personalisation span').data('text-max');
			
			jQuery('.line-item-property__personalisation #enter-your-text').bind('keyup', function(e){
				var charLimit = max - jQuery(this).val().length;

	    	jQuery('.line-item-property__personalisation .text-limit').html(charLimit);

	    	if(charLimit < max) {
	    		jQuery('.line-item-property__personalisation').attr('data-personalise', true);
	    	} else {
	    		jQuery('.line-item-property__personalisation').attr('data-personalise', false);
	    	}
			});
		}
	}

	// Get Feefo star from API method
	function pdpFeefoStars() {
		let parentfeefoID = jQuery('.product__reviews').data('parent-product-sku');
		if(parentfeefoID) {
			jQuery.ajax({
	      url: 'https://api.feefo.com/api/20/products/ratings?merchant_identifier=mamas-and-papas&parent_product_sku='+ parentfeefoID + '&review_count=true&since=all'
	      })
	      .done(function( data ) {
					if(data.hasOwnProperty("reviews")) {
						var review_count = data.reviews.length;
						var reviewsFinalAverage = 0;
						for(var i=0; i<review_count; i++) {
							if (data.reviews[i].customer) {
							} else {
							}
							reviewsFinalAverage += data.reviews[i].products[0].rating.rating
						}
						var score = reviewsFinalAverage / review_count
						var rating = Math.round(score);
						if(review_count) {
							jQuery('.product__reviews').removeClass('hide');
							jQuery('.tabs [data-feefo-review-input]').removeClass('hide');
							jQuery('.tabs [data-feefo-review-label]').removeClass('hide');
							jQuery('.tabs [data-feefo-review-panel]').removeClass('hide');

							jQuery('.product__reviews').each(function(){
								for(var i=0; i<rating; i++) {
									jQuery(this).find('.product__reviews-stars .fa').eq(i).removeClass('fa-star-o');
									jQuery(this).find('.product__reviews-stars .fa').eq(i).addClass('fa-star');
									jQuery(this).find('.product__reviews-stars .fa').eq(i).addClass('checked');
								}
							});
							
							jQuery('.product__reviews-link [data-feefo-count]').text(review_count);
							jQuery('.feefowidget-product-stars__reviews-count').text(review_count);
						} else {
							jQuery('.tabs [data-feefo-review-input]').removeClass('hide');
							jQuery('.tabs [data-feefo-review-label]').removeClass('hide');
							jQuery('.tabs [data-feefo-review-panel]').removeClass('hide');
							jQuery('#feefo-product-review-widgetId').append('<div>There are no reviews for this product yet</div>');
						}
					} else {
						if(data.hasOwnProperty("products")) {
							var review_count = data.products.length;
							var reviewsFinalAverage = 0;
							var reviewsFinalCount = 0;
							for(var i=0; i<review_count; i++) {
								reviewsFinalAverage += data.products[i].rating
								reviewsFinalCount += data.products[i].review_count
							}
							var score = reviewsFinalAverage / review_count;
							var reviewsTotal = reviewsFinalCount;
							var rating = Math.round(score);
							var reviewsTotalrating = Math.round(reviewsTotal);
							if(review_count) {
								jQuery('.product__reviews').removeClass('hide');
								jQuery('.tabs [data-feefo-review-input]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-label]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-panel]').removeClass('hide');
	
								
								jQuery('.product__reviews').each(function(){
									for(var i=0; i<rating; i++) {
										jQuery(this).find('.product__reviews-stars .fa').eq(i).removeClass('fa-star-o');
										jQuery(this).find('.product__reviews-stars .fa').eq(i).addClass('fa-star');
										jQuery(this).find('.product__reviews-stars .fa').eq(i).addClass('checked');
									}
								});
								
								jQuery('.product__reviews-link [data-feefo-count]').text(reviewsTotalrating);
								jQuery('.feefowidget-product-stars__reviews-count').text(review_count);
								
							} else {
								jQuery('.tabs [data-feefo-review-input]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-label]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-panel]').removeClass('hide');
								jQuery('#feefo-product-review-widgetId').append('<div>There are no reviews for this product yet</div>');
							}
						}
					}
	      });
	  } else {
			var feefoID = jQuery('.product__reviews').data('feefo-sku');
			if(feefoID) {
				jQuery.ajax({
					url: 'https://api.feefo.com/api/20/products/ratings?merchant_identifier=mamas-and-papas&product_sku='+ feefoID + '&review_count=true&since=all'
					})
					.done(function( data ) {
						if(data.hasOwnProperty("products")) {
							var review_count = data.products[0].review_count;
							var rating = Math.round(data.products[0].rating);
	
							if(review_count) {
								jQuery('.product__reviews').removeClass('hide');
								jQuery('.tabs [data-feefo-review-input]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-label]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-panel]').removeClass('hide');
	
								jQuery('.product__reviews').each(function(){
									for(var i=0; i<rating; i++) {
										jQuery(this).find('.product__reviews-stars .fa').eq(i).removeClass('fa-star-o');
										jQuery(this).find('.product__reviews-stars .fa').eq(i).addClass('fa-star');
										jQuery(this).find('.product__reviews-stars .fa').eq(i).addClass('checked');
									}
								});
								
								jQuery('.product__reviews-link [data-feefo-count]').text(review_count);
							} else {
								jQuery('.tabs [data-feefo-review-input]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-label]').removeClass('hide');
								jQuery('.tabs [data-feefo-review-panel]').removeClass('hide');
								jQuery('#feefo-product-review-widgetId').append('<div>There are no reviews for this product yet</div>');
							}
						}
					});
			 }
		}
	}

	// Scroll to review tab when click on Feefo link
	function pdpFeefoSroll() {
		jQuery(document).on( 'click', '.product__reviews-link', function(e){
	    e.preventDefault();
	    var scrollAnchor = jQuery(this).attr('href');
	    var scrollPos = jQuery(scrollAnchor);
	    var stickyHeaderTopElementHeight = jQuery('.site-top__wrapper').outerHeight();
	    var stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight() - stickyHeaderTopElementHeight;
	    
	    jQuery('.product-single__description').each(function(){
	    	jQuery(this).find('input').prop('checked', false).trigger('click').trigger('change');
	    });

	    jQuery('input[data-feefo-review-input]').prop('checked', true).trigger('click').trigger('change');

	    if (!jQuery('label[data-feefo-review-label]').hasClass('active')) {
		  	jQuery('label[data-feefo-review-label]').addClass('active');
		  }

		  if (!jQuery('div[data-feefo-review-panel]').hasClass('active')) {
		  	jQuery('div[data-feefo-review-panel]').addClass('active');
		  }
		  
	    jQuery('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'slow');
	  });
	}

	//PDP Tab to Accordion for mobile
  function pdpTabToAccordion() {
  	jQuery(document).on( 'click', '.tabs label span', function(e){
  		e.preventDefault();

  		var id = jQuery(this).parent().attr('aria-controls');
  		var tabLabel = jQuery(".tabs label[aria-controls='"+ id +"']");
  		var tabPanel = jQuery('.tabs #'+id);

  		tabLabel.toggleClass('active');
  		tabPanel.toggleClass('active');
  	});
  }

  //Add tooltip to worth price icon
  function worthPriceToolTip() {
  	if ($(window).width() < 1024) {
			$(".worth-price-icon").click(function(e){
				e.preventDefault();
				$(this).parent().find('.worth-price-info').toggleClass('hide');
			});
	  }
	  else {
			$(".worth-price-icon").hover(function(){
				$(this).parent().find('.worth-price-info').toggleClass('hide');
			});
	  }
  }

  //Add ATB function to store drawer
  function pdpStoreLocatorDrawerAddItem() {
  	jQuery(document).on( 'click', '#store-locator .js-onstate-input-store-select--submit', function(e){
  		e.preventDefault();

  		jQuery("#store-locator button.btn--close").trigger("click");
  		jQuery('form.product-form').submit();
  	});
  }

  if (jQuery('body').hasClass('template-customers-login') || jQuery('body').hasClass('template-customers-register') || jQuery('body').hasClass('template-customers-account')){
  	//Set data capturing global counter for primary selector
  	//Maximum allowed input fields 
  	var maxFields = 99;
  	//Initial input field is set to 1
  	var childCounter = 1;

  	addInputFields();
  	addInputFieldsBorn();
  };

  
  //Add Input Fields
  function addInputFields() {
    var add_button = jQuery(".register_add_fields"); //Add button class or ID

    jQuery(document).on( 'click', 'a.register_add_fields', function(e){
  		e.preventDefault();
  		var inputFieldHtml = "";
  		var wrapper = jQuery(this).parent().parent().find(".register_input_wrapper"); //Input fields wrapper

      //Check maximum allowed child input fields
      if (childCounter < maxFields) {
        childCounter++; //input field increment
        //add input field

        inputFieldHtml +=
        '<div class="grid__item customerform-dynamicfields customerform-due">'
          +'<div class="grid grid--half-gutters">'
            +'<div class="grid__item-date grid__item medium-down--nine-twelfths medium-up--ten-twelfths float-label">'
              +'<input class="customerform-js-field-date" id="Child-' + childCounter + '-dueDate" max="9999-12-31" type="date" name="osCustomer[Children][' + childCounter + '][DOB]" placeholder="Input Text Here" />'
              +'<label for="Child-' + childCounter + '-dueDate">'+ theme.strings.dueChild +'</label>'
            +'</div>'
            +'<div class="grid__item medium-down--three-twelfths medium-up--two-twelfths customerform-remove">'
              +'<a href="javascript:void(0);" class="remove_field">'+ theme.strings.removeChild +'</a>'
            +'</div>'
          +'</div>'
        +'</div>';

    		wrapper.append(inputFieldHtml);

    		if (childCounter == maxFields) {
    			jQuery(".customerform-register-add-fields").hide();
    		}
			} 
		});

		//when user click on remove child button
    jQuery(document).on("click", ".register_input_wrapper .remove_field", function(e) {
      e.preventDefault();
      jQuery(this).parent('div').parent('div').remove(); //remove input field
      childCounter--; //input field decrement

      jQuery(".customerform-register-add-fields").show();
    })
  }

  //Data capturing primary selector
  jQuery(document).on( 'click', 'input.registerRadio', function(e){
  	//jQuery('input.registerRadio').click(function () {
    var inputValue = jQuery(this).data("type");
    var targetBox = jQuery("." + inputValue);
    jQuery(".customerform-box").not(targetBox).hide();
    jQuery(".customerform-js-relationship").prop('checked', false); //reset radio
    jQuery(targetBox).show();
    //Add reset counter and remove dynamic fields
    childCounter = 1;
    jQuery(".register_input_wrapper .customerform-dynamicfields").remove();
    jQuery(".customerform-register-add-fields").show();

    if (jQuery('body').hasClass('template-customers-account')) {
    	jQuery(".journey-form-footer").show();
    }
  });

  //Add Input Fields
  function addInputFieldsBorn() {
    var add_button = jQuery(".customerform-register-add-fieldsborn"); //Add button class or ID

    jQuery(document).on( 'click', 'a.customerform-register-add-fieldsborn', function(e){
    	e.preventDefault();
      var inputFieldHtml = "";
      var wrapper = jQuery(this).parent().parent().find(".register_input_wrapper"); //Input fields wrapper

      //Check maximum allowed input fields
      if (childCounter < maxFields) {
        childCounter++; //input field increment
        //add input field

        inputFieldHtml +=
        '<div class="grid__item customerform-dynamicfields customerform-born">'
          +'<div class="grid grid--half-gutters">'
            +'<div class="grid__item medium-down--one-half medium-up--one-half customerform-genderbox float-label">'
              +'<select class="customerform-js-field-select" id="child-' + childCounter + '-[bornGender]" name="osCustomer[Children][' + childCounter + '][Gender]">'
                +'<option value="" disabled selected>Please select</option>'
                +'<option label="Boy" value="M">Boy</option>'
                +'<option label="Girl" value="F">Girl</option>'
                +'<option label="Unknown" value="U">Unknown</option>'
                +'<option label="Rather not say" value="R">Rather not say</option>'
              +'</select>'
              +'<label for="child-' + childCounter + '-[bornGender]">'+ theme.strings.childGender +'</label>'
            +'</div>'
            +'<div class="grid__item medium-down--one-half medium-up--one-half customerform-namebox float-label">'
               +'<input class="customerform-js-field-name" type="text" maxlength="25" id="child-' + childCounter + '-[bornName]" name="osCustomer[Children][' + childCounter + '][Name]" placeholder="Name" />'
               +'<label for="child-' + childCounter + '-[bornName]">Name</label>'
            +'</div>'
            +'<div class="grid__item-date grid__item medium-down--nine-twelfths medium-up--ten-twelfths float-label">'
              +'<input max="9999-12-31" class="customerform-js-field-date" id="child-' + childCounter + '-[bornDate]" type="date" name="osCustomer[Children][' + childCounter + '][DOB]" placeholder="Input Text Here" />'
              +'<label for="child-' + childCounter + '-[bornDate]">'+ theme.strings.bornChild +'</label>'
            +'</div>'
            +'<div class="grid__item medium-down--three-twelfths medium-up--two-twelfths customerform-remove">'
              +'<a href="javascript:void(0);" class="remove_fieldborn">'+ theme.strings.removeChild +'</a>'
            +'</div>'
          +'</div>'
        +'</div>';
        
        wrapper.append(inputFieldHtml);

        if (childCounter == maxFields) {
    			jQuery(".customerform-register-add-fields").hide();
    		}
      }
    });

    //when user click on remove button
    jQuery(document).on("click", ".register_input_wrapper .remove_fieldborn", function(e) {
      e.preventDefault();
      jQuery(this).parent('div').parent('div').remove(); //remove inout field
      childCounter--; //inout field decrement

      jQuery(".customerform-register-add-fields").show();
    })
  }

  function form2Json(str) {
    "use strict";
    var obj, i, pt, keys, j, ev;
    if (typeof form2Json.br !== 'function') {
      form2Json.br = function (repl) {
        if (repl.indexOf(']') !== -1) {
          return repl.replace(/\](.+?)(,|$)/g, function ($1, $2, $3) {
            return form2Json.br($2 + '}' + $3);
          });
        }
        return repl;
      };
    }
    str = '{"' + (str.indexOf('%') !== -1 ? decodeURI(str) : str) + '"}';
    obj = str.replace(/\=/g, '":"').replace(/&/g, '","').replace(/\[/g, '":{"');
    obj = JSON.parse(obj.replace(/\](.+?)(,|$)/g, function ($1, $2, $3) {
      return form2Json.br($2 + '}' + $3);
    }));
    pt = ('&' + str).replace(/(\[|\]|\=)/g, '"$1"').replace(/\]"+/g, ']').replace(/&([^\[\=]+?)(\[|\=)/g, '"&["$1]$2');
    pt = (pt + '"').replace(/^"&/, '').split('&');
    for (i = 0; i < pt.length; i++) {
      ev = obj;
      keys = pt[i].match(/(?!:(\["))([^"]+?)(?=("\]))/g);
      for (j = 0; j < keys.length; j++) {
        if (!ev.hasOwnProperty(keys[j])) {
          if (keys.length > (j + 1)) {
            ev[keys[j]] = {};
          } else {
            ev[keys[j]] = pt[i].split('=')[1].replace(/"/g, '');
            break;
          }
        }
        ev = ev[keys[j]];
      }
    }
    return obj;
  }

	$('.usp__row').slick({
  	dots: false,
  	arrows: false,
  	infinite: true,
  	slidesToShow: 4,
  	slidesToScroll: 2,
  	autoplay:true,
  	speed: 1500,
  	autoplaySpeed: 3000,
  	pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
  	responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    }
  	]
	});

  //Filter arrow rotation, active class and visibility.
  jQuery(document).on("click", ".menu-featured-categories-container .title__cat", function (e) {
      e.preventDefault();
      $(this).toggleClass("active__filter");
      $(this).parent().find(".sub-menu").toggleClass("invisible");
      $(this).parent().find(".icon-chevron-down").toggleClass("rotated");
    }
  );

	initAddressForm();
	initSignupForms();

	function togglePostcodeRequired() {
		let noPostcodeCountries = [ 'Angola', 'Antigua and Barbuda', 'Aruba', 'Ascension island', 'Bahamas', 'Belize', 'Benin', 'Botswana', 'Bolivia', 'Bonaire, Sint Eustatius and Saba', 'Burkina Faso', 'Burundi', 'Cameroon', 'Central African Republic', 'Comoros', 'Congo - Kinshasa', 'Congo - Brazzaville', 'Cook Islands', 'Cote d’Ivoire', 'Curaçao', 'Djibouti', 'Dominica', 'East Timor', 'Equatorial Guinea', 'Eritrea', 'Fiji', 'French Southern Territories', 'Gambia', 'Gambon', 'Ghana', 'Grenada', 'Guyana', 'Heard and McDonald Islands', 'Hong Kong', 'Kiribati', 'Libya', 'Macau', 'Malawi', 'Mali', 'Mauritania', 'Nauru', 'Netherlands Antilles', 'Niue', 'North Korea', 'Qatar', 'Rwanda', 'Saint Kitts and Nevis', 'Sao Tome and Principe', 'Seychelles', 'Sierra Leone', 'Solomon Islands', 'Suriname', 'Syria', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Tuvalu', 'Uganda', 'United Arab Emirates', 'Vanuatu', 'Yemen', 'Zimbabwe' ];
		let selectedCountry = jQuery( '.address-country-option:visible, #AddressCountryNew:visible' ).val();
		console.log( selectedCountry, noPostcodeCountries.includes( selectedCountry ) );
		if( noPostcodeCountries.includes( selectedCountry ) ) {
			jQuery( 'input[name="address[zip]"]:visible' ).removeAttr( 'required' ).removeClass( 'required' ).removeClass( 'input--error' );
		} else {
			jQuery( 'input[name="address[zip]"]:visible' ).attr( 'required', 'required' ).addClass( 'required' )
		}
	}
	jQuery( document ).on( 'click', '.address-edit-toggle', togglePostcodeRequired );
	jQuery( document ).on( 'input change', '.address-country-option:visible', togglePostcodeRequired );
	jQuery( document ).on( 'input change', '#AddressCountryNew:visible', togglePostcodeRequired );
	togglePostcodeRequired();

	guestPaymentForm();
	trackOrderForm();

	if( jQuery( '#RegisterForm' ).is( ':visible' ) ) {
		jQuery( '#RegisterForm' ).submit( function( e ) {
			e.preventDefault();
	
			jQuery( '#RegisterForm' ).removeAttr( 'onsubmit' );
	
			return false;
		});

		initRegisterForm();
	}

	if( jQuery( 'form#mp-form-newsletter-signup' ).is( ':visible' ) ) {
		jQuery( 'form#mp-form-newsletter-signup' ).submit( function( e ) {
			e.preventDefault();
	
			jQuery( 'form#mp-form-newsletter-signup' ).removeAttr( 'onsubmit' );
	
			return false;
		});

		initEmailSignupForm();
	}

	if( jQuery( 'form#mp-form-update-family' ).is( ':visible' ) ) {
		jQuery( 'form#mp-form-update-family' ).submit( function( e ) {
			e.preventDefault();
	
			jQuery( 'form#mp-form-update-family' ).removeAttr( 'onsubmit' );
	
			return false;
		});

		initFamilyUpdateForm();
	}

	if( jQuery( 'form#mp-form-birth-date' ).is( ':visible' ) ) {
		jQuery( 'form#mp-form-birth-date' ).submit( function( e ) {
			e.preventDefault();
	
			jQuery( 'form#mp-form-birth-date' ).removeAttr( 'onsubmit' );
	
			return false;
		});

		initBirthDateForm();
	}
});

function giftCardCustomValidation() {
	// Manually check if a design has been selected
	if( jQuery( '[name="cards-group"]:checked' ).val() == undefined ) {
		window.giftCardFormIsValid = false;
		if( jQuery( '#cards-group-error' ).length == 0 ) {
			let message = 'Please select a design';
			let $newError = jQuery( '<span id="cards-group-error" class="step-error-message input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + message + '</span></span>' );
			$newError.appendTo( '.step__1 .step-header' );
			$newError.css( 'position', 'static' );
		}
	} else {
		jQuery( '#cards-group-error' ).remove();
	}

	// Manually check the amount has been selected
	let cardGroupVal = jQuery( '[name="amount-group"]:checked' ).val();
	let cardCustomVal = jQuery( '[name="amount-custom"]' ).val();

	if( cardGroupVal == undefined && cardCustomVal == "" ) {
		window.giftCardFormIsValid = false;
		if( jQuery( '#amount-error' ).length == 0 ) {
			let message = 'Please choose or enter an amount';
			let $newError = jQuery( '<span id="amount-error" class="step-error-message input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + message + '</span></span>' );
			$newError.appendTo( '.step__2 .step-header' );
			$newError.css( 'position', 'static' );
		}
	} else {
		jQuery( '#amount-error' ).remove();
	}

	if( jQuery( '[name="cards-group"]:checked' ).val() == undefined ) {
		let scrollPos = jQuery('#section-step-1');
		let stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight();
		jQuery('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'smooth');
	} else {
		let cardGroupVal = jQuery( '[name="amount-group"]:checked' ).val();
		let cardCustomVal = jQuery( '[name="amount-custom"]' ).val();
		if( cardGroupVal == undefined && cardCustomVal == "" ) {
			let scrollPos = jQuery('#section-step-2');
			let stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight();
			jQuery('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'smooth');
		}
	}

	jQuery( document ).on( 'change', '[name="cards-group"]', function() {
		jQuery( '#cards-group-error' ).remove();
	});

	jQuery( document ).on( 'change', '[name="amount-group"],[name="amount-custom"]', function() {
		jQuery( '#amount-error' ).remove();
	});
}

function giftCardHandler(){
	window.giftCardFormIsValid = true;

	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	
	setTimeout(function(){
    	jQuery.validator.addMethod( 'emailRfc', function( value, element ) {
			let regex = /(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
			return value.match( regex );
		});
    }, 1000);

	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( giftCardHandler, 250 ); 
		return;
	}

	jQuery( 'form#giftCardForm' ).validate({
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			jQuery( element ).parent().find( '.input-error-message' ).remove();
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {2
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			}
		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}, messages: {
			toName: "Please enter the recipient's name",
			toAddress: "Please enter a valid email address",
			confirmAddress: "This email address does not match",
			fromName: "Please enter your name"
    }, rules: {
			fromAddress: {
				emailRfc: true
			},
			toAddress: {
				emailRfc: true
			}
		}, invalidHandler: function( event, validator ){
			window.giftCardFormIsValid = true;
			giftCardCustomValidation();
		}, submitHandler: function( form, event ) {
			window.giftCardFormIsValid = true;
			giftCardCustomValidation();
			if( !window.giftCardFormIsValid ) {
				return false;
			}

			let formData = jQuery( form ).serialize();

			// Generate endpoint URL
			let endpointUrl = _baseUrl + 'createGiftCard';
			let callback    = 'createGiftCardCallback';

			// Retrieve product SKU
			let selectedDesign = jQuery( '[name=cards-group]:checked' );
			let productSku = selectedDesign.data( 'sku' );

			// Grab the image as well
			let imageUrl = selectedDesign.parents( 'label' ).find( 'img' ).attr( 'src' );

			// Add to the payload data
			formData = formData + '&sku=' + productSku;
			formData = formData + '&image=' + imageUrl;

			// Track submission
			pushGcTrackingData( 'PDP', 'Continue to pay' );

			// Send field data to the middleware endpoint using JSONP
			jQuery.ajax({
				url          : endpointUrl,
				dataType     : 'jsonp',
				data         : formData,
				jsonpCallback: callback,
				// timeout      : 10000,			@TODO
				// error        : myAccountIsDown 	@TODO
			});
		}
	});

	giftCardPdpBalanceCheckForm();
	giftCardPdpTracking();
}

function giftCardPdpTracking() {
	jQuery( document ).on( 'change', '[name="cards-group"]', function( event ) {
		pushGcTrackingData( 'Select Card Design', jQuery( this ).val() );
	});

	jQuery( document ).on( 'change', '[name="amount-group"]', function( event ) {
		pushGcTrackingData( 'Select Card Value', jQuery( this ).val() );
	});

	jQuery( document ).on( 'change', '[name="amount-custom"]', function( event ) {
		if( jQuery( this ).hasClass( 'input--error' ) == false ) {
			pushGcTrackingData( 'Enter Card Value', jQuery( this ).val() );
		}
	});

	jQuery( document ).on( 'click', 'h4.accordion-toggle', function() {
		pushGcTrackingData( 'PDP', jQuery( this ).text() );
	});
}

function recaptchaCallback() {
	console.log( 'recaptchaCallback' );
	jQuery( 'a.buy-gift-card' ).removeAttr( 'disabled' );
	jQuery( '#btn-check-balance' ).removeAttr( 'disabled' );
}

function giftCardBalanceCheckDatalayer() {
	jQuery( document ).on( 'click', 'a.buy-gift-card', function() {
		pushGcTrackingData( 'Balance Page', 'Buy a Gift Card' );
	});
	jQuery( document ).on( 'click', 'h4.accordion-toggle', function() {
		pushGcTrackingData( 'Balance Page', jQuery( this ).text() );
	});
}

function giftCardPdpBalanceCheckForm() {
	jQuery( document ).on( 'submit', '#giftCardPdpBalanceCheckForm', function( e ) {
		e.preventDefault();

		// Get form data
		let formData = jQuery( this ).serialize();

		let baseUrl = ( useLocalhost ? 'http://localhost' : 'https://' + _contactServerDomain ) + '/control/giftcards/';

		// Generate endpoint URL
		let endpointUrl = baseUrl + 'giftCardBalance';
		let callback    = 'giftCardBalanceCallback';

		// Track submission
		let submitLocation = 'PDP';
		if( jQuery( 'body' ).is( '.full-template-page-gift-card-balance' ) ) {
			submitLocation = 'Balance Page';
		}
		pushGcTrackingData( submitLocation, 'Check my balance request' );

		// Send field data to the middleware endpoint using JSONP
		jQuery.ajax({
			url          : endpointUrl,
			dataType     : 'jsonp',
			data         : formData,
			jsonpCallback: callback,
			// timeout      : 10000,			@TODO
			// error        : myAccountIsDown 	@TODO
		});
	});

	jQuery( document ).on( 'click', '#checkAnotherCard', function() {
		jQuery( '#balance-check-input-1' ).val( '' );
		jQuery( '#balance-check-input-2' ).val( '' );
		jQuery( '#balance-check-input-2' ).parent().hide();
		jQuery( '.checkFormWrapper' ).show();
		jQuery( '.checkResultWrapper' ).hide();
		grecaptcha.reset(); // Reset the reCAPTCHA when checking another card
	});
}

function giftCardBalanceCallback( response ) {
	// Clear any errors previously set
	jQuery( '#giftCardPdpBalanceCheckForm input' ).removeClass( 'input--error' );
	jQuery( '#balanceCheckError' ).remove();
	grecaptcha.reset();

	// Handle errors first
	if( !response.success ) {
		let message;
		let $newError;
		if( response.error == 'INVALID SECURITY' ) {
			message = 'Invalid security code';
			$newError = jQuery( '<span id="balanceCheckError" class="step-error-message input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + message + '</span></span>' );
			jQuery( '#balance-check-input-2' ).addClass( 'input--error' );
			$newError.appendTo( '#giftCardPdpBalanceCheckForm .float-label:last' );
		} else if ( response.error == 'INVALID CARD NO' ) {
			message = 'Invalid card number';
			$newError = jQuery( '<span id="balanceCheckError" class="step-error-message input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + message + '</span></span>' );
			jQuery( '#balance-check-input-1' ).addClass( 'input--error' );
			$newError.appendTo( '#giftCardPdpBalanceCheckForm .float-label:first' );
		} else if ( response.error == 'NOT IN DATE' ) {
			message = 'This gift card has expired';
			$newError = jQuery( '<span id="balanceCheckError" class="step-error-message input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + message + '</span></span>' );
			jQuery( '#balance-check-input-1' ).addClass( 'input--error' );
			$newError.appendTo( '#giftCardPdpBalanceCheckForm .float-label:first' );
		}
	}
	
	// Success response
	if( response.success && response.balance != undefined ) {
		// Format balance
		let symbol = ( Shopify.currency.active == 'GBP' ) ? '£' : '€';
		let balance = symbol + parseFloat(response.balance).toFixed(2);

		// Display
		jQuery( '.checkFormWrapper' ).hide();
		jQuery( '.checkResultWrapper .giftCardNumber' ).html( jQuery( '#balance-check-input-1' ).val() );
		jQuery( '.checkResultWrapper .giftCardBalance' ).html( balance );
		jQuery( '.checkResultWrapper' ).show();
	} else if( response.success && response.balance == undefined ) {
		let message = 'This gift card is invalid';
		let $newError = jQuery( '<span id="balanceCheckError" class="step-error-message input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + message + '</span></span>' );
		$newError.appendTo( '#giftCardPdpBalanceCheckForm .float-label:first' );
	}
}

function createGiftCardCallback( response ) {
	if( response.success ) {
		cartStorageManager.saveCartToLocalStorage(true).then(() => {
			document.location = response['invoice_url'];
		}).catch((error) => {
			console.error('Error saving cart to local storage:', error);
			document.location = response['invoice_url'];
		});
	}
}

var useLocalhost  = false;       // debug remove
if( getCookieValue( 'useLocalhost' ) != undefined && getCookieValue( 'useLocalhost' ) == 'true' ) {
	useLocalhost = true;
}
var _baseUrl = ( useLocalhost ? 'http://localhost' : 'https://' + _contactServerDomain ) + '/control/mamaspapas/';

function trackOrderForm() {
	if( jQuery( 'form#trackOrder' ).length == 0 ) {
		return false;
	}

	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( trackOrderForm, 250 ); 
		return;
	}

	let form = jQuery( 'form#trackOrder' );
	let _validateConf = {
		errorClass: 'input--error',
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			}
		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();  
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}, messages: {
			emailAddress: "Please enter the email address used on the order",
			orderNumber: "Please enter your order number"
		}
	};

	form.validate( _validateConf );

	jQuery( document ).on( 'submit', 'form#trackOrder', function( event ) {
		event.preventDefault();

		let formData = form.serialize();
		form.validate( _validateConf );

		if( !form.valid() ) {
			return;
		}

		let _url = _baseUrl + 'getOrderTrackingDetails';

		//Show pages for now
		jQuery.ajax({
			url: _url,
			dataType: 'jsonp',
			data: formData,
			jsonpCallback: 'getOrderTrackingDetailsCallback'
		});

	});
}

function getOrderTrackingDetailsCallback( data ) {
	if( data.success == false ) {
		jQuery( '.submit-status' ).show();
		return;
	}

	// Todo error
	jQuery(".guest-trackorder-page .page-1").hide();
	jQuery(".guest-trackorder-page .page-2").show();
	jQuery('#guest-trackorder-page').toggleClass('my-order');

	data = formatOrderDetailsData( data );

	let output = buildTemplate( 'order', data );
	jQuery(".guest-trackorder-page .page-2").html( output );
}

function getTemplateSelector( templateId ) {
    return '[data-template="' + templateId + '"]';
}

function buildTemplate( templateName, data ) {
    let outputContainer = jQuery( '<div></div>' );
    let output = getTemplate( templateName );

    let dataSrc = output.data( 'src' );


    if( dataSrc != undefined ) {
        if( dataSrc.includes( '.' ) ) {
            let dataNest = dataSrc.split( '.' );
            if( data[ dataNest[ 0 ] ] != undefined ) {
                data = ( data[ dataNest[ 0 ] ][ dataNest[ 1 ] ] != undefined ) ? data[ dataNest[ 0 ] ][ dataNest [ 1 ] ] : {};
            }
        } else {
            data = ( data[ dataSrc ] != undefined ) ? data[ dataSrc ] : {};
        }
    }
    
    if( !Array.isArray( data ) ) {
        data = [ data ];
    }

    data.forEach( function( data, index, array ) {
        let outputElement = output.clone();

        let propertyElements = outputElement.find( '[data-property]' );
        propertyElements.each( function(){
            let property      = jQuery( this ).data( 'property' );
            let propertyType  = jQuery( this ).data( 'type' );
            let propertyValue = data[ property ];

            if( propertyValue == undefined && propertyType != 'display' ) {
				
                console.log( 'no ' + property + ' value in ' + outputElement.data( 'template' ) );
                return;
            }

            // Do we need to transform this value
            let transform = jQuery( this ).data( 'transform' );
            if( transform != undefined && typeof window[ transform ] == 'function' ) {
                propertyValue = window[ transform ]( propertyValue );
            }

            if( propertyType != undefined ) {
                if( propertyType == 'display' ) {
                    // boolean hide/display
                    if( propertyValue != 'true' && propertyValue != true ) {
                        jQuery( this ).remove();
                    }
                } else {
                    // set propertyType
                    jQuery( this ).attr( propertyType, propertyValue );
                }
            } else {
                jQuery( this ).html( propertyValue );
            }
        });

        // Sub templates?
        if( outputElement.find( '[data-sub]' ).length > 0 ) {
            outputElement.find( '[data-sub]' ).each( function(){
                let subTemplate = jQuery( this ).data( 'sub' );
                let markup = buildTemplate( subTemplate, data );

                jQuery( this ).html( markup.html() );
            });
        }

        outputContainer.append( outputElement );
    });

    // if( output.data( 'echodata' ) != undefined ) {
        console.log( '------ ' + templateName + ' ------' );
        console.log( data );
    // }

    return outputContainer;
}

var guestTemplateContainer = jQuery( '#templates-container' );

function getTemplateSelector( templateId ) {
    return '[data-template="' + templateId + '"]';
}

function getTemplate( templateId ) {
    let templateSelector = getTemplateSelector( templateId );
    let template = guestTemplateContainer.find( templateSelector ).clone();
    return template;
}

function formatOrderDetailsData( data ) {
    if( data == undefined || data.statusText == 'error' || data.statusText == 'load' ) {
        return {};
    }

    data.paidValue             = 0;
    data.isOverdue             = false;
    data.needsPayment          = false;
    data.showPaymentInfo       = false;
    data.showCollectionMessage = false;
    data.showShipments         = false;
    
    let orderNumber = data.orderNumber;
    // dataStore.orders.orders.forEach( function( element, index, array ){
    //     if( element.orderNumber == orderNumber ) {
    //         data.orderHeader = element;
    //         return;
    //     }
    // });

    if( data.paymentInfo != undefined && data.paymentInfo.length > 0 ) {
        data.showPaymentInfo = true;
        data.paymentInfo.forEach( function( value, index ) {
            data.paidValue = data.paidValue + value.paidAmount;
        });
    }

    // if( data.orderHeader.outstandingValue != undefined && data.orderHeader.outstandingValue > 0 ) {
    //     data.needsPayment = true;
    // }

    // data.paymentMessages = data.orderHeader.messages;

    if( data.paymentMessages != undefined && data.paymentMessages.length > 0 ) {
        data.paymentMessages.forEach( function( message ) {
            message.outstandingValue = data.orderHeader.outstandingValue;
			message.minimum          = 5;
            message.paymentDueDate   = data.orderHeader.paymentDueDate;
            message.paidValue        = data.paidValue;
            message.makePaymentLink  = 'payment&orderNumber=' + orderNumber;

            let tsDue = Date.parse( message.paymentDueDate );
            if( Date.now() > tsDue ) {
                message.isOverdue = true;
                data.isOverdue = true;
            }
        });
    }

    if( data.shipmentMessages != undefined && data.shipmentMessages.length > 0 ) {
        data.showShipments = true;
        data.shipmentMessages.forEach( function( message, messageIndex ) {
            message.statusClass    = message.text.toLowerCase().replace( / /g, '-' );
            message.addressHeader  = 'Delivery address';
            message.expectedHeader = 'Expected delivery';
            if( message.statusClass.includes( 'collect' ) ) {
                message.addressHeader  = 'Store address';
                message.expectedHeader = 'Expected collection by';
                message.showCollectionMessage = true;
            }
            if( message.statusClass == 'collected' ) {
                message.expectedHeader = 'Date collected';
                message.showCollectionMessage = false;
            }
            if( message.shipments != undefined && message.shipments.length > 0 ) {
                message.shipments.forEach( function( shipment, shipmentIndex ) {
                    shipment.editDeliveryAddress = ( messageIndex == 0 && shipmentIndex == 0 ) ? data.editDeliveryAddress : false;
                    shipment.editDeliveryDate    = ( messageIndex == 0 && shipmentIndex == 0 ) ? data.editDeliveryDate : false;

                    shipment.addressLink = 'order/address&orderNumber=' + data.orderNumber;
                    shipment.dateLink    = 'order/date&orderNumber=' + data.orderNumber;

                    shipment.addressHeader = message.addressHeader;
                    shipment.expectedHeader = message.expectedHeader;

                    shipment.showTracking = ( shipment.trackingUrl != undefined && shipment.trackingUrl != "" );
                    shipment.isDropship = false;
                    shipment.isNotDropship = true;

                    shipment.lineItems.forEach( function( lineItem ) {
                        lineItem.isPersonalised = false;
                        if( lineItem.customisation != undefined && lineItem.customisation != "" ) {
                            lineItem.isPersonalised = true;
                        }

                        if( lineItem.isDrophip || lineItem.isDropship ) {
                            shipment.isDropship    = true;
                            shipment.isNotDropship = false;
                        }

                        if( lineItem.productName == "Web balance item" ) {
                            data.showShipments = false;
                        }
                    });

                    if( ( data.editDeliveryAddress && shipment.isDropship ) || ( data.editDeliveryDate && shipment.isDropship ) ) {
                        shipment.showDropshipMessage = true;
                    } else {
                        shipment.showDropshipMessage = false;
                    }
                });
            }
        });
    }

    return data;
}

function guestPaymentForm() {
	if( jQuery( 'form#payBalance' ).length == 0 ) {
		return false;
	}

	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( guestPaymentForm, 250 );
		return;
	}
	
	let dataObj = {};
	let urlPath = window.location.search;
	if( urlPath.includes( '&' ) ){
        let splitPath = urlPath.split( '&' );
        urlPath = splitPath[ 0 ];

        splitPath.slice( 1 ).forEach( function( element, index, array ){
            let splitData = element.split( '=', 2 );
            dataObj[ splitData[ 0 ] ] = splitData[ 1 ];
        });
    }

	if( dataObj.orderNumber != undefined ) {
		jQuery( '[name=orderNumber]' ).val( dataObj.orderNumber );
	}

	if( dataObj.orderSurname != undefined ) {
		jQuery( '[name=orderSurname]' ).val( dataObj.orderSurname );
	}

	let _validateConf = {
		errorClass: 'input--error',
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			jQuery( element ).parent().find( '.input-error-message' ).remove();
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			}
		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();  
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}, messages: {
			orderNumber: "Please enter your order number",
			orderSurname: "Please enter the surname used on the order"
		}, rules: {
			valueToPay: {
				number: true,
				minimumValue: true,
				maximumValue: true
			}
		}
	};

	jQuery( document ).on( 'click', 'label[for=paymentType]', function() {
		jQuery( this ).parent().find( 'input[type=radio]' ).attr( 'checked', 'checked' ).click();
	});

	jQuery( document ).on( 'input', '[name=valueToPay]', function( event ) {
		if( parseFloat( jQuery( this ).val() ) > 0 ) {
			jQuery( '[name=paymentType][value=part]' ).click();
		}

		if($(this).val().indexOf('.')!=-1){         
            if($(this).val().split(".")[1].length > 2){                
                if( isNaN( parseFloat( this.value ) ) ) return;
                this.value = parseFloat(this.value).toFixed(2);
            }  
        }
	});

	jQuery( document ).on( 'submit', 'form#payBalance', function( e ) {
		e.preventDefault();

		let form = jQuery('#payBalance');
		let formData = form.serialize();
		form.validate( _validateConf );

		addValidationMethods();

		if( !form.valid() ) {
			return;
		}

		let _url = _baseUrl + 'getPaymentDetailsOrderSurname';

		//Show pages for now
		jQuery.ajax({
			url: _url,
			dataType: 'jsonp',
			data: formData,
			jsonpCallback: 'getPaymentDetailsOrderSurnameCallback'
		});
	});

	jQuery( document ).on( 'submit', 'form#createdraftorder', function( e ){
		e.preventDefault();

		let form = jQuery( this );
		let formData = form.serialize();
		form.validate( _validateConf );

		if( !form.valid() ) {
			return;
		}

		let _url = _baseUrl + 'createDraftOrder';

		cartStorageManager.saveCartToLocalStorage(true).then(() => {
			jQuery.ajax({
				url: _url,
				dataType: 'jsonp',
				data: formData,
				jsonpCallback: 'createDraftOrderCallback'
			});
		}).catch((error) => {
			console.error('Error saving cart to local storage:', error);
			jQuery.ajax({
				url: _url,
				dataType: 'jsonp', 
				data: formData,
				jsonpCallback: 'createDraftOrderCallback'
			});
		});      

	});
}

function getPaymentDetailsOrderSurnameCallback( data ) {
	if( data.success == false ) {
		jQuery( '.submit-status .warning' ).show();
	} else {
		let order = data[ 'orders' ][ 0 ];
		order[ 'lastName' ] = data.surname;
		order.minimum = 5;

		if( order.allowPayment == undefined ) {
			order.allowPayment = true;
		}
		order.preventPayment   = !order.allowPayment;

		order.partPaymentMade  = ( order.outstanding > 0 && order.paid > 0 );
        order.noPaymentMade    = ( order.paid == 0 );

		order.preventPaymentMsg = 'You have no outstanding payments at this time.';

		if( order.partPaymentMade ) {
			order.preventPaymentMsg = 'Further payments can be made when previous payments have been processed.';
		}

		jQuery(".guest-payment-page .page-1").hide();
		jQuery(".guest-payment-page .page-2").show();

		jQuery( '.page-2 [data-property]' ).each( function(){
			let property = jQuery( this ).data( 'property' );
			let propertyValue = order[ property ];

			let transform = jQuery( this ).data( 'transform' );
            if( transform != undefined && typeof window[ transform ] == 'function' ) {
                propertyValue = window[ transform ]( propertyValue );
            }
			
			if( jQuery( this ).data( 'type' ) != undefined ) {
                let attribute = jQuery( this ).data( 'type' );
                if( attribute == 'display' ) {
                    // boolean hide/display
                    if( propertyValue != 'true' && propertyValue != true ) {
                        jQuery( this ).remove();
                    }
                } else {
                    // set attribute
                    jQuery( this ).attr( attribute, propertyValue );
                }
            } else {
                jQuery( this ).html( propertyValue );
            }
		});
	}
}

function createDraftOrderCallback( data ) {
	if( data.success == true ) {
		cartStorageManager.saveCartToLocalStorage(true).then(() => {
			window.location = data["invoice_url"];
		}).catch((error) => {
			console.error('Error saving cart to local storage:', error);
			window.location = data["invoice_url"];
		});
	}
}

function formatPrice( price, currencyCode ) {
    if( currencyCode == undefined ) {
        var currencyCode = Shopify.currency.active;
    }

    let symbol = ( currencyCode == 'GBP' ) ? '£' : '€';
    let formattedPrice = price.toFixed( 2 ).toLocaleString( 'en-US' );

    return symbol + formattedPrice;
}

function formatDateString( dateString ) {
    let date = new Date( dateString );
    return date.toLocaleDateString( 'en-GB' );
}

function initAddressForm() {
	if( !jQuery( 'body').hasClass( 'template-customers-addresses' ) ) {
		return;
	}

	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( initAddressForm, 250 );
		return;
	}

	let validateConf = {
		errorClass: 'input--error',
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			}
		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();  
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}
	};

	jQuery( '#address_form_new' ).validate( validateConf );
	jQuery( '.myaccount__addresses form' ).validate( validateConf );
	jQuery( document ).on( 'click', '.address-edit-toggle', function() {
		let targetContainerId = jQuery( this ).attr( 'aria-owns' );
		let $target = jQuery( '#' + targetContainerId ).find( 'form' );
		$target.validate( validateConf );
		console.log( $target.valid() );
	});
}

function initSignupForms() {
	$ = jQuery;
	$("form.js-newsletter-signup").submit(function(e){
		e.preventDefault();

		$(this).addClass('js-active-signup-form');

		config = {};

		//*
		config.callback = "signupThankYou";
		//*/

		$(this).signup(config);
		return false;
	});

	$("form.js-newsletter-signup-version2").submit(function (e) {
		e.preventDefault();

		// Setup error message div
		var el = $("form.js-newsletter-signup-version2");
		$(".error", $(el)).remove();

		let customerName = "";

		// Get First Name and add it to customerName
		if ($("[name=grow_fname]").val() != "") {
			customerName = $("[name=grow_fname]").val()
		}

		// Get Last Name and add it to customerName
		if ($("[name=grow_lname]").val() != "") {
			customerName = customerName + " " + $("[name=grow_lname]").val()
		}

		customerEmail = jQuery("#js-newsletter-signup-email").val()
		// Set customer name
		$("[name=name]").val(customerName);

		// Get dob
		let dob = $("[name=dob]").val();

		if (!checkEmail(customerEmail)) {
			return false;
		}

		let validateDate = true;

		// Date is not required if data did not come from Join Grow
		if (jQuery("[name=source]").length > 0) {
			validateDate = false;
		}

		if (validateDate) {
			if (dob == "") {
				return false;
			}
		}

		// Check if date is valid
		if (dob != "") {
			if (checkDate(dob)) {
				if (getAge(dob) > 4 || !dobTwoYears(dob)) {
					$(el).append("<div class='error'>Your date is too far in the future or past. Please check your dates and try again.</div>");
					return false;
				}
			}
		}

		// Submit form if there are no errors
		$(this).addClass('js-active-signup-form');
		config = {};
		config.callback = "signupThankYouNewsletter";
		$(this).signup(config);
		return false;

	});


}


function dobTwoYears(dob){
	// let d = new Date(dob  + " " + "23:00");
    let d = new Date(dob);
    let f1 = d.setFullYear(d.getFullYear());

	let c = new Date();
	let f2 = c.setFullYear(c.getFullYear() + 1); // Updated to only 1 year

	if (f2 > f1) {
		console.log('within  1 year')
		return true
	} else {
		console.log('Not within  1 year')
		return false;
	}
}

function getAge(bday) {
	// bday= bday + " " + "00:00";
	// bday= bday ;
	var dob = new Date(bday);
	//calculate month difference from current date in time
	var month_diff = Date.now() - dob.getTime();

	//convert the calculated difference in date format
	var age_dt = new Date(month_diff);

	//extract year from date
	var year = age_dt.getUTCFullYear();

	//now calculate the age of the user
	var age = Math.abs(year - 1970);

	//display the calculated age
	return age;
}

function checkDate(dob) {
	var el = $("form.js-newsletter-signup-version2");
	$(".error",$(el)).remove();

	d = new Date(dob);
	let result = d instanceof Date && !isNaN(d);

	if (!result) {
		$(el).append("<div class='error'>Invalid Date</div>");
	}

	return result
}

function checkEmail(email) {
	var el = $("form.js-newsletter-signup-version2");
	$(".error",$(el)).remove();

	errorMsg = "Please enter a valid email address. "
	chk = /^[\w\.%\+\-]+@[a-z0-9.-]+\.(com|gov|in|jo|org|co.uk)$/i.test(email);

	if (!chk) {
		$(el).append("<div class='error'>" + errorMsg + "</div>");
	}

	return chk;
}

function signupThankYouNewsletter(respone) {
	errorMsg = "";
	var el = $("form.js-newsletter-signup-version2.js-active-signup-form");

	$(".error",$(el)).remove();

	$(el).removeClass('js-active-signup-form');

	if(respone.error) {
		//append error
		errorMsg = respone.error
		if (respone.error == "newsletter_invalid_email") {
			errorMsg = "Please enter a valid email address."
		}
		
		$(el).append("<div class='error'>"+errorMsg+"</div>");
	} else {
		//clear form, show confirmation
		// $(el).empty().append(theme.strings.collectiveThankyou);

		if (jQuery("[name=source]").length > 0) {
			window.location.href = "https://" +  window.location.hostname + "/pages/thank-you-newsletter-signup"
		}else{
			window.location.href = "https://" +  window.location.hostname + "/pages/thank-you-join-grow"
		}


	}

	if ($(window).width() < 1024) {
		var scrollPos = $('form.js-newsletter-signup');
		var stickyHeaderTopElementHeight = jQuery('.site-top__wrapper').outerHeight();
		var stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight() + stickyHeaderTopElementHeight;

		$('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'fast');
	}
}

function signupThankYou(respone) {

	var el = $("form.js-newsletter-signup.js-active-signup-form");

	$(".error",$(el)).remove();

	$(el).removeClass('js-active-signup-form');

	if(respone.error) {
		//append error
		$(el).append("<div class='error'>"+respone.error+"</div>");
	} else {
		//clear form, show confirmation
		$(el).empty().append(theme.strings.collectiveThankyou);
	}

  if ($(window).width() < 1024) {
    var scrollPos = $('form.js-newsletter-signup');
    var stickyHeaderTopElementHeight = jQuery('.site-top__wrapper').outerHeight();
    var stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight() + stickyHeaderTopElementHeight;

    $('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'fast');
  }
}

jQuery(document).ready(function() {

	jQuery( document ).on( 'submit', '#firstStep', function (e) {
		e.preventDefault();
		jQuery( '.found-order-id' ).text( jQuery( '#initOrderNumber').val() );
		jQuery( '.found-order-name' ).text( jQuery( '#initOrderSurname').val() );
		jQuery( '#orderNumber').val( jQuery( '#initOrderNumber').val() );
		jQuery( '#orderSurname').val( jQuery( '#initOrderSurname').val() );
		jQuery( '#payBalance' ).show();
		jQuery( '#firstStep' ).hide();
	})

  jQuery(window).load(function() {
    //Scroll to top on first load in Captcha page
    if (jQuery('body').hasClass('template-captcha')){
      jQuery('html,body').animate({scrollTop: 0},'slow');
    };

    //Scroll to success message when a success sign up
    if (jQuery('.site-footer__newsletter .form-message--success').length || 
      jQuery('.site-footer__newsletter #ContactFooter-email-error').length){
      var scrollPos = jQuery('.site-footer__newsletter');
      var stickyHeaderTopElementHeight = jQuery('.site-top__wrapper').outerHeight();
      var stickyHeaderElementHeight = jQuery('#shopify-section-header').outerHeight() - stickyHeaderTopElementHeight;
      
      jQuery('html,body').animate({scrollTop: scrollPos.offset().top - stickyHeaderElementHeight},'fast');
    };

  });
});

(function($){
	$(function(){
		if($("#validate-script").length > 0) {
			_I = setInterval(function(){
				if( typeof $().validate == "undefined" ) {
					$( '#validate-script' ).attr( 'src', $( '#validate-script' ).attr( 'data-src' ) );
				} else {
					clearInterval(_I);
				}
			},250)
		}
	});
})(jQuery);

(function($){
	$(function(){

		$("#ContactFooter").submit(function(e){
			e.preventDefault();
      //console.log("submitting");
			//$(this).addClass('js-active-signup-form');
	
			config = {};
	
			//*
			config.callback = "footerStage1";
			//*/
	
			$(this).signup(config);
			return false;
		});


	});
})(jQuery);


function footerStage1(respone) {
	$.ajax({
		url:'/pages/_contact_popup',
		complete:function(a,b){
			$("body").append("<div class='modal-popup'>"+a.responseText+"</div>");
			config = {};
			config.callback = "footerStage2";
			$('.modal-popup form').submit(function(e){
				e.preventDefault();
				$(this).addClass('js-active-signup-form');
				$(this).signup(config);
				return false;
			});
			
      $('.modal-popup .btn--close').click(function(e){
        $('.modal-popup').remove();
      });
		}
	});
}

function footerStage2(respone) {
	var el = $("form.js-newsletter-signup.js-active-signup-form");

	$(".error",$(el)).remove();

	$(el).removeClass('js-active-signup-form');

	if(respone.error) {
		//append error
		$(el).append("<div class='error'>"+respone.error+"</div>");
	} else {
		//clear form, show confirmation
		$(el).empty().append(theme.strings.collectiveThankyou);
	}
}
	
function addValidationMethods() {
	jQuery.validator.addMethod( 'minimumValue', function( value, element ) {
        if( jQuery( '[name=paymentType]:checked' ).val() == 'full' ) {
			return true;
		} else if( parseFloat( value ) >= 5 ) {
			return true;
		} else {
			return false;
		}
    }, 'Please enter at least 5 or above' );

    jQuery.validator.addMethod( 'maximumValue', function( value, element ) {
		if( jQuery( '[name=paymentType]:checked' ).val() == 'full' ) {
			return true;
		} else if( parseFloat( value ) <= jQuery( '[name=outstandingValue]' ).val() ) {
			return true;
		} else {
			return false;
		}
    }, 'You cannot pay more than the outstanding balance' );
}

function pushGcTrackingData( action, label ) {
	let pushMe = {
        category: "Gift Cards",
        event: "Gift Cards",
        action: action,
        label: label
    };

	dataLayer.push( pushMe );
	console.log( 'gcTrack', pushMe );
}

/* 

Section for Data capturing project

*/

/* Registration form */
function initRegisterForm() {
	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( initRegisterForm, 250 ); 
		return;
	}

	jQuery( '#RegisterForm' ).validate({
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			} else {
				jQuery( element ).parent().find( '.input-error-message span' ).html(error.html());
			}
		}, submitHandler: function( form, event ) {
			jQuery( document ).find( '.customerform-js-field-date:visible' ).each( function(){
				jQuery( this ).rules( "add", {
					checkDob: true
				});

				if( jQuery( this ).val() == '') {
					let gender = jQuery( this ).parent().parent().find('.customerform-js-field-select').val();
					let name = jQuery( this ).parent().parent().find('.customerform-js-field-name').val();
					//console.log("Date:'"+jQuery( this ).val()+"' Gender:'"+gender+"' Name:'"+name+"'");
					if( gender !== undefined && name !== undefined ) {
						//console.log("Gender and name input are visible")
						if((gender == null && name != '') || (gender != null && name == '') || (gender != null && name != '')) {
							//console.log("Trigger required rule")
							jQuery( this ).rules( "add", {
								required: true
							});
						}
					}
				}
			});

			jQuery.validator.addMethod( 'checkDob', function( value, element ) {		

				if( value == "" ) {
					return true;
				}

				// Calculate age if past
				let result   = false;
				let dob      = new Date( value );
				let ageDelta = new Date( Date.now() - dob.getTime() );
				let year     = ageDelta.getUTCFullYear();
				let age      = Math.abs( year - 1970 );
		
				// Calculate check for future
				let d = new Date( value );
				let f1 = d.setFullYear(d.getFullYear());
		
				let c = new Date();
				let f2 = c.setFullYear(c.getFullYear() + 1); // Updated to only 1 year
		
				if (f2 > f1) {
					if( age < 5 ) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}, 'Your date is too far in the future or past' );

			if( !jQuery( 'form#RegisterForm' ).valid() ) {
				return false;
			}

			let relationship = jQuery( 'input[name="osCustomer[Relationship]"]:checked' ).val();
			if(relationship == null || relationship == undefined) {
				relationship = "";
			}

			let journeyObject = {};
			journeyObject.customer = {};
			journeyObject.customer.relationship = relationship;
			journeyObject.customer.children = [];
			journeyObject.customer.child_count = 0;

			if( jQuery( '.customerform-js-field-date:visible' ).length > 0 ) {
				jQuery( '.customerform-js-field-date:visible' ).each( function() {
					if( jQuery( this ).val() != '' ) {
						let gender = jQuery( this ).parent().parent().find('.customerform-js-field-select').val();
						if( gender == undefined || gender == null ) {
							gender = "U";
						}

						let name = jQuery( this ).parent().parent().find('.customerform-js-field-name').val();
						if( name == undefined || name == null ) {
							name = "";
						}

						journeyObject.customer.children.push( {
							"id": 0,
							"name": name,
							"gender": gender,
							"date": jQuery( this ).val(),
							"link_id": 0,
							"active": true
						});
					}
				});
			}

			let journeyString = JSON.stringify( journeyObject );
			jQuery("input[name='customer[note]']").val(journeyString);

			//console.log(journeyString);
			form.submit();
		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}
	});
}

/* Newsletter signup */
function initEmailSignupForm() {
	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( initEmailSignupForm, 250 ); 
		return;
	}

	jQuery( 'form#mp-form-newsletter-signup' ).validate({
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			} else {
				jQuery( element ).parent().find( '.input-error-message span' ).html(error.html());
			}
		}, submitHandler: function( form, event ) {
			jQuery( document ).find( '.customerform-js-field-date:visible' ).each( function(){
				jQuery( this ).rules( "add", {
					checkDob: true
				});

				if( jQuery( this ).val() == '') {
					let gender = jQuery( this ).parent().parent().parent().find('.customerform-js-field-select').val();
					let name = jQuery( this ).parent().parent().parent().find('.customerform-js-field-name').val();
					//console.log("Date:'"+jQuery( this ).val()+"' Gender:'"+gender+"' Name:'"+name+"'");
					if( gender !== undefined && name !== undefined ) {
						//console.log("Gender and name input are visible")
						if((gender == null && name != '') || (gender != null && name == '') || (gender != null && name != '')) {
							//console.log("Trigger required rule")
							jQuery( this ).rules( "add", {
								required: true
							});
						}
					}
				}
			});

			jQuery.validator.addMethod( 'checkDob', function( value, element ) {		
				if( value == "" ) {
					return true;
				}

				// Calculate age if past
				let result   = false;
				let dob      = new Date( value );
				let ageDelta = new Date( Date.now() - dob.getTime() );
				let year     = ageDelta.getUTCFullYear();
				let age      = Math.abs( year - 1970 );
		
				// Calculate check for future
				let d = new Date( value );
				let f1 = d.setFullYear(d.getFullYear());
		
				let c = new Date();
				let f2 = c.setFullYear(c.getFullYear() + 1); // Updated to only 1 year
		
				if (f2 > f1) {
					if( age < 5 ) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}, 'Your date is too far in the future or past' );

			if( !jQuery( 'form#mp-form-newsletter-signup' ).valid() ) {
				return false;
			}

			let queryChild = "";
			let queryChildIndex = 0;
			if( jQuery( '.customerform-js-field-date:visible' ).length > 0 ) {
				jQuery( '.customerform-js-field-date:visible' ).each( function() {
					if( jQuery( this ).val() != '' ) {
						let gender = jQuery( this ).parent().parent().parent().find('.customerform-js-field-select').val();
						if( gender == undefined || gender == null ) {
							gender = "U";
						}

						let name = jQuery( this ).parent().parent().parent().find('.customerform-js-field-name').val();
						if( name == undefined || name == null ) {
							name = "";
						}

						queryChild += '&' + "children["+queryChildIndex+"][gender]" + "=" + encodeURIComponent(gender).replace(/%20/g,'+');
						queryChild += '&' + "children["+queryChildIndex+"][name]" + "=" + encodeURIComponent(name).replace(/%20/g,'+');
						queryChild += '&' + "children["+queryChildIndex+"][date]" + "=" + encodeURIComponent(jQuery( this ).val()).replace(/%20/g,'+');

						queryChildIndex++;
					}
				});
			}
			console.log(queryChild);
			
			const formData = new FormData(form);
			const entires = formData.entries();
			let query = "";
			for(var input of entires) {
				if(input[0].includes("child-")) {
					//Skip child
				} else {
					if(input[0] != "submit") {
						if(input[0] == "customer[relationship]") {
							if(input[1]) {
								if(input[1] == 1 || input[1] == 2) {
									input[1] = "parent";
								}

								if(input[1] == 3) {
									input[1] = "gifter";
								}

								console.log(input[0] + '=' + input[1]);
								query += '&' + input[0] + "=" + encodeURIComponent(input[1]).replace(/%20/g,'+');
							}
						} else {
							console.log(input[0] + '=' + input[1]);
							query += '&' + input[0] + "=" + encodeURIComponent(input[1]).replace(/%20/g,'+');
						}
					}
				}
			}
			query = query.substring(1)+queryChild;
			console.log(query);
			
			// Middleware URL
			let baseUrl = ( useLocalhost ? 'http://localhost' : 'https://' + _contactServerDomain ) + '/control/myfamily/';
			// Generate endpoint URL
			let endpointUrl = baseUrl + 'newsletterSignup';

			console.log("endpointUrl: "+endpointUrl);

			jQuery.ajax({
				type: "POST",
				url: endpointUrl,
				data: query,
				success : function() {
					console.log("CHILD SAVE");
					window.location.href = "https://" +  window.location.hostname + "/pages/thank-you-email-sign-up";
				},
				error : function(error) {
					console.log("CHILD NOT SAVE");
					jQuery( document ).find('.custom-data-loyalty .connection-error-message').text(error.responseJSON.error).show();

					if( jQuery('.custom-data-loyalty .connection-error-message.mismatch-name').length ) {
						jQuery('.custom-data-loyalty .connection-error-message').removeClass('mismatch-name');
					}

					if( error.responseJSON.error == "Please ensure the email address and name entered matches the information held in your Mamas & Papas account." ) {
						jQuery('.custom-data-loyalty .connection-error-message').addClass('mismatch-name');
					}
				}
			});

		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}
	});
}

/* Family Update */
function initFamilyUpdateForm() {
	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( initFamilyUpdateForm, 250 ); 
		return;
	}

	jQuery( 'form#mp-form-update-family' ).validate({
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			} else {
				jQuery( element ).parent().find( '.input-error-message span' ).html(error.html());
			}
		}, submitHandler: function( form, event ) {
			jQuery( document ).find( '.customerform-js-field-date:visible' ).each( function(){
				jQuery( this ).rules( "add", {
					checkDob: true
				});

				if( jQuery( this ).val() == '') {
					let gender = jQuery( this ).parent().parent().parent().find('.customerform-js-field-select').val();
					let name = jQuery( this ).parent().parent().parent().find('.customerform-js-field-name').val();
					//console.log("Date:'"+jQuery( this ).val()+"' Gender:'"+gender+"' Name:'"+name+"'");
					if( gender !== undefined && name !== undefined) {
						//console.log("Gender and name input are visible")
						if((gender == null && name != '') || (gender != null && name == '') || (gender != null && name != '')) {
							//console.log("Trigger required rule")
							jQuery( this ).rules( "add", {
								required: true
							});
						}
					}
				}
			});

			jQuery.validator.addMethod( 'checkDob', function( value, element ) {		
				if( value == "" ) {
					return true;
				}

				// Calculate age if past
				let result   = false;
				let dob      = new Date( value );
				let ageDelta = new Date( Date.now() - dob.getTime() );
				let year     = ageDelta.getUTCFullYear();
				let age      = Math.abs( year - 1970 );
		
				// Calculate check for future
				let d = new Date( value );
				let f1 = d.setFullYear(d.getFullYear());
		
				let c = new Date();
				let f2 = c.setFullYear(c.getFullYear() + 1); // Updated to only 1 year
		
				if (f2 > f1) {
					if( age < 5 ) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}, 'Your date is too far in the future or past' );

			if( !jQuery( 'form#mp-form-update-family' ).valid() ) {
				return false;
			}

			let queryChild = "";
			let queryChildIndex = 0;
			if( jQuery( '.customerform-js-field-date:visible' ).length > 0 ) {
				jQuery( '.customerform-js-field-date:visible' ).each( function() {
					if( jQuery( this ).val() != '' ) {
						let gender = jQuery( this ).parent().parent().parent().find('.customerform-js-field-select').val();
						if( gender == undefined || gender == null ) {
							gender = "U";
						}

						let name = jQuery( this ).parent().parent().parent().find('.customerform-js-field-name').val();
						if( name == undefined || name == null ) {
							name = "";
						}

						queryChild += '&' + "children["+queryChildIndex+"][gender]" + "=" + encodeURIComponent(gender).replace(/%20/g,'+');
						queryChild += '&' + "children["+queryChildIndex+"][name]" + "=" + encodeURIComponent(name).replace(/%20/g,'+');
						queryChild += '&' + "children["+queryChildIndex+"][date]" + "=" + encodeURIComponent(jQuery( this ).val()).replace(/%20/g,'+');

						queryChildIndex++;
					}
				});
			}
			console.log(queryChild);

			const formData = new FormData(form);
			const entires = formData.entries();
			let query = "";
			for(var input of entires) {
				if(input[0].includes("child-")) {
					//Skip child
				} else {
					if(input[0] != "submit") {
						if(input[0] == "customer[relationship]") {
							if(input[1]) {
								if(input[1] == 1 || input[1] == 2) {
									input[1] = "parent";
								}

								if(input[1] == 3) {
									input[1] = "gifter";
								}

								console.log(input[0] + '=' + input[1]);
								query += '&' + input[0] + "=" + encodeURIComponent(input[1]).replace(/%20/g,'+');
							}
						} else {
							console.log(input[0] + '=' + input[1]);
							query += '&' + input[0] + "=" + encodeURIComponent(input[1]).replace(/%20/g,'+');
						}
					}
				}
			}
			query = query.substring(1)+queryChild;;
			console.log(query);
			
			// Middleware URL
			let baseUrl = ( useLocalhost ? 'http://localhost' : 'https://' + _contactServerDomain ) + '/control/myfamily/';
			// Generate endpoint URL
			let endpointUrl = baseUrl + 'newsletterSignup?find_or_fail';

			console.log("endpointUrl: "+endpointUrl);

			jQuery.ajax({
				type: "POST",
				url: endpointUrl,
				data: query,
				success : function() {
					console.log("CHILD SAVE");
					window.location.href = "https://" +  window.location.hostname + "/pages/thank-you-update-child";
				},
				error : function(error) {
					console.log("CHILD NOT SAVE");
					jQuery( document ).find('.custom-data-loyalty .connection-error-message').text(error.responseJSON.error).show();

					if( jQuery('.custom-data-loyalty .connection-error-message.mismatch-name').length ) {
						jQuery('.custom-data-loyalty .connection-error-message').removeClass('mismatch-name');
					}

					if( error.responseJSON.error == "Please ensure the email address and name entered matches the information held in your Mamas & Papas account." ) {
						jQuery('.custom-data-loyalty .connection-error-message').addClass('mismatch-name');
					}
				}
			});

		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}
	});
}

/* Birth date */
function initBirthDateForm() {
	// Load validate
	jQuery( '#validate-script' ).attr( 'src', jQuery( '#validate-script' ).attr( 'data-src' ) );
	console.log( 'loading validate...' );

	if( typeof jQuery().validate == "undefined" ) {
		console.log( 'no validate, retrying..' ); 
		setTimeout( initBirthDateForm, 250 ); 
		return;
	}

	jQuery( 'form#mp-form-birth-date' ).validate({
		errorPlacement: function( error, element ){
			let errorId = element.attr("id") + '-error';
			if( jQuery( element ).parent().find( '.input-error-message' ).length == 0 ) {
				let $newError = jQuery( '<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>' );
				$newError.insertAfter( element );
			}
		}, submitHandler: function( form, event ) {
			jQuery( document ).find( '.customerform-js-field-date:visible' ).each( function(){
				jQuery( this ).rules( "add", {
					checkDob: true
				});
			});

			jQuery.validator.addMethod( 'checkDob', function( value, element ) {		
				if( value == "" ) {
					return true;
				}

				// Calculate age if past
				let result   = false;
				let dob      = new Date( value );
				let ageDelta = new Date( Date.now() - dob.getTime() );
				let year     = ageDelta.getUTCFullYear();
				let age      = Math.abs( year - 1970 );
		
				// Calculate check for future
				let d = new Date( value );
				let f1 = d.setFullYear(d.getFullYear());
		
				let c = new Date();
				let f2 = c.setFullYear(c.getFullYear() + 1); // Updated to only 1 year
		
				if (f2 > f1) {
					if( age < 5 ) {
						return true;
					} else {
						return false;
					}
				} else {
					return false;
				}
			}, 'Your date is too far in the future or past' );

			if( !jQuery( 'form#mp-form-birth-date' ).valid() ) {
				return false;
			}

			const formData = new FormData(form);
			const entires = formData.entries();
			let query = "";
			let childIndex = 1;

			for(var input of entires) {
				if(input[0].includes("child-")) {
					if(input[0].includes("child-"+mainDisplayPos)) {
						if(input[0].includes("child-"+mainDisplayPos+"-id")) {
							input[0] = "children["+(Math.ceil(childIndex/5)-1)+"][id]";
						}

						if(input[0].includes("child-"+mainDisplayPos+"-active")) {
							input[0] = "children["+(Math.ceil(childIndex/5)-1)+"][active]";
						}

						if(input[0].includes("child-"+mainDisplayPos+"-gender")) {
							input[0] = "children["+(Math.ceil(childIndex/5)-1)+"][gender]";
							if(input[1] == '') {
								input[1] = 'U';
							}
						}

						if(input[0].includes("child-"+mainDisplayPos+"-name")) {
							input[0] = "children["+(Math.ceil(childIndex/5)-1)+"][name]";
						}

						if(input[0].includes("child-"+mainDisplayPos+"-dob")) {
							input[0] = "children["+(Math.ceil(childIndex/5)-1)+"][date]";
						}
						console.log(input[0] + '=' + input[1]);
						query += '&' + input[0] + "=" + encodeURIComponent(input[1]).replace(/%20/g,'+');
						childIndex++;
					}
				} else {
					if(input[0] != "submit") {
						console.log(input[0] + '=' + input[1]);
						query += '&' + input[0] + "=" + encodeURIComponent(input[1]).replace(/%20/g,'+');
					}
				}
			}
			query = query.substring(1);
			console.log(query);
			
			let searchParams = new URLSearchParams(window.location.search);
			let param = '';
			if(searchParams.has('token')) {
				param = searchParams.get('token');
				console.log(param);
			}

			// Middleware URL
			let baseUrl = ( useLocalhost ? 'http://localhost' : 'https://' + _contactServerDomain ) + '/control/myfamily/';
			// Generate endpoint URL
			let endpointUrl = baseUrl + 'massChildUpdate?token='+param;

			console.log("endpointUrl: "+endpointUrl);

			jQuery.ajax({
				type: "POST",
				url: endpointUrl,
				data: query,
				success : function() {
					console.log("CHILD SAVE");
					window.location.href = "https://" +  window.location.hostname + "/pages/thank-you-update-child";
				},
				error : function(error) {
					console.log("CHILD NOT SAVE");
					jQuery( document ).find('.custom-data-loyalty .connection-error-message').text(error.responseJSON.error).show();
				}
			});

		}, highlight: function( element, errorClass, validClass ) {
			$( element ).addClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).show();
		}, unhighlight: function( element, errorClass, validClass ) {
			$( element ).removeClass( 'input--error' );
			$( element ).parent().find( '.input-error-message' ).hide();
		}
	});
}

/**
 * Cart Storage Manager
 * 
 * Used primarily in Gift Card Purchases & Balance Payments where customers
 * are taken to a secondary checkout flow to complete their order. Upon
 * returning to the store, the customers original cart is loaded from local storage.
 */
class CartStorageManager {
    static AUTO_APPLY_KEY = 'cartStorage_autoApply';
    static STORED_CART_KEY = 'cartStorage_storedCart';

    constructor() {
        this.autoApply = localStorage.getItem(CartStorageManager.AUTO_APPLY_KEY) === 'true';
        if (this.autoApply && localStorage.getItem(CartStorageManager.STORED_CART_KEY)) {
            this.loadCartFromLocalStorage();
        }
    }

	async refreshMinicart() {
		$.ajax({
		url: '/cart?view=json&_dc='+btoa(Date.now() + Math.random()),
		success: function(data){
			var cartData = JSON.parse(data);
			
			//Update header item count
			theme.Cart.prototype._setCartCountBubble(cartData.cart.item_count);

			//Update cart total count
			jQuery('[data-cart-quantity]').html(cartData.cart.item_count);

			//Clear cart container
			jQuery('[data-cart-itemlist]').empty();

			//update cart's footer
			mpUpdateCartFooter(cartData);

			//render the cart
			mpRenderCartHtml(cartData);

			//Untrigger empty cart state
			if(jQuery('[data-cart-itemlist]').hasClass('hide')) {
				jQuery('[data-cart-empty]').addClass('hide');
				jQuery('[data-cart-itemlist]').removeClass('hide');
				jQuery('[data-drawer-footer]').removeClass('hide');
				}
			}
		})		
	}

    async saveCartToLocalStorage(autoApply = false) {
        try {
            const cart = await this.getCart();
            const cartData = JSON.stringify(cart);
            localStorage.setItem(CartStorageManager.STORED_CART_KEY, cartData);
            localStorage.setItem(CartStorageManager.AUTO_APPLY_KEY, autoApply);
            console.log('[CARTSTORAGE] Cart saved to local storage.', cart);
        } catch (error) {
            console.error('[CARTSTORAGE] Error saving cart to local storage:', error);
        }
    }

    async loadCartFromLocalStorage() {
        try {
            const cartData = localStorage.getItem(CartStorageManager.STORED_CART_KEY);
            if (!cartData) {
                console.log('[CARTSTORAGE] No cart data found in local storage.');
                return;
            }	

			console.log('[CARTSTORAGE] Loading cart from local storage.', cartData);

            // Clear the current cart
            await fetch(window.Shopify.routes.root + 'cart/clear.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

			console.log('[CARTSTORAGE] Cart cleared.');

            const cart = JSON.parse(cartData).cart;
            const items = cart.items.map(item => ({
                id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties
            }));

			console.log('[CARTSTORAGE] Items mapped.', items);

            // Add items to the cart
            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ items })
            });

			console.log('[CARTSTORAGE] Items added to cart.');

            // Update cart attributes and note
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: cart.attributes,
                    note: cart.note
                })
            });

			console.log('[CARTSTORAGE] Cart attributes and note updated.');

            console.log('[CARTSTORAGE] Cart loaded from local storage.');

			await this.clearCartFromLocalStorage();

            console.log('[CARTSTORAGE] Cart data removed from local storage after loading. Refreshing minicart.');

			await this.refreshMinicart();
        } catch (error) {
            console.error('[CARTSTORAGE] Error loading cart from local storage:', error);
        }
    }

    async clearCartFromLocalStorage() {
        try {
            localStorage.removeItem(CartStorageManager.STORED_CART_KEY);
            localStorage.removeItem(CartStorageManager.AUTO_APPLY_KEY);
            console.log('[CARTSTORAGE] Cart cleared from local storage.');
        } catch (error) {
            console.error('[CARTSTORAGE] Error clearing cart from local storage:', error);
        }
    }

    async getCart() {
        const response = await fetch(`/cart?view=json`);
        const data = await response.json();
        return data;
    }
}

const cartStorageManager = new CartStorageManager();

window.addEventListener('DOMContentLoaded', async () => {
	setTimeout(async () => {
		await cartStorageManager.refreshMinicart();
	}, 1000);
});

/**
 * Contact form manager
 * 
 * Used to handle contact form validation and image uploads 
 */
class ContactFormManager {

	static MAX_FILE_SIZE = 10; // 10MB
	static height = 800;
	static width = 800;

	constructor(debugMode = false) {
		this.uploadedImages = {};
		this.debugMode = debugMode;
		this.initContactForm();
	}

	log(message, ...optionalParams) {
		if (this.debugMode) {
			console.log(`[CONTACTFORM] ${message}`, ...optionalParams);
		}
	}

	initContactForm() {
		this.log('Initializing contact form...');
		// Only execute on contacts page
		if (jQuery('body').hasClass('full-template-page-contact-new') == false) {
			this.log('Not on contact page, exiting initContactForm.');
			return;
		}

		// Load validate
		jQuery('#validate-script').attr('src', jQuery('#validate-script').attr('data-src'));
		this.log('Loading validate script...');

		if (typeof jQuery().validate == "undefined") {
			this.log('Validate script not loaded, retrying...');
			setTimeout(() => this.initContactForm(), 250);
			return;
		}

		this.log('Contact form loaded.');

		if (window.location.search == '?success=true') {
			jQuery('#form-success').show();
			jQuery([document.documentElement, document.body]).animate({
				scrollTop: $("#form-success").offset().top - 200
			}, 0);
			this.log('Form success message displayed.');
		}

		jQuery(document).on('change', '#contact_image', (e) => {
			this.log('Image input changed.');
			if (e.target.files && e.target.files[0]) {
				this.handleImageUpload(e.target.files[0]);
			}
		});

		jQuery(document).on('click', '.contact-image-remove', (e) => {
			e.preventDefault();
			let $contactImage = jQuery(e.target).parents('.contact-image');
			let imageKey = $contactImage.attr('data-image-key');
			this.handleImageRemoval(imageKey);
		});

		if (jQuery('#contact_form').length > 0) {
			jQuery('#contact_form').validate({
				errorPlacement: function (error, element) {
					let errorId = element.attr("id") + '-error';
					if (jQuery(element).parent().find('.input-error-message').length == 0) {
						let $newError = jQuery('<span id="' + errorId + '" class="input-error-message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z" fill-rule="nonzero" data-gtm-vis-has-fired-31351932_557="1" data-gtm-vis-has-fired-31351932_550="1"></path></g></svg><span>' + error.html() + '</span></span>');
						$newError.insertAfter(element);
					}
				},
				submitHandler: (form, event) => {
					this.log('Form submitted.');
					jQuery(form).find('[name=redirect]').remove();
					jQuery('<input type="hidden" name="redirect">').val(window.location.href.replace(window.location.search, '')).appendTo(form);
					// Do reCAPTCHA verification
					grecaptcha.execute();
					jQuery(form).find('input[type=submit]').val('Sending...').attr('disabled', 'disabled');
				},
				highlight: function (element, errorClass, validClass) {
					$(element).addClass('input--error');
					$(element).parent().find('.input-error-message').show();
				},
				unhighlight: function (element, errorClass, validClass) {
					$(element).removeClass('input--error');
					$(element).parent().find('.input-error-message').hide();
				}
			});
		}
	}

	async handleImageUpload(file) {
		this.log('Handling image upload...');
		if (file && /^image\//i.test(file.type)) {
			this.readFile(file);
		} else {
			alert('Not a valid image!');
		}
	}

	async handleImageRemoval(imageKey) {
		this.log('Handling image removal for key:', imageKey);
		const imageData = this.uploadedImages[imageKey];
		if (imageData) {
			imageData.inputElement.remove();
			imageData.previewElement.remove();
			delete this.uploadedImages[imageKey];
			this.log('Uploaded images:', this.uploadedImages);
		}
		if (jQuery('#contact_form .contact-images > div').length == 0) {
			jQuery('#contact_form .contact-images').hide();
		}
	}

	processFileSize(file) {
		this.log('Processing file size...');
		if (file.size > ContactFormManager.MAX_FILE_SIZE * 1024 * 1024) {
			alert('File size exceeds the maximum limit of 10MB.');
			return false;
		}
		return true;
	}

	readFile(file) {
		this.log('Reading file...');
		var reader = new FileReader();

		reader.onloadend = () => {
			this.processFile(reader.result, file.type);
		}

		reader.onerror = () => {
			alert('There was an error reading the file!');
		}

		reader.readAsDataURL(file);
	}

	processFile(dataURL, fileType) {
		this.log('Processing file...');
		var image = new Image();

		let imageKey = 'image_' + Math.random().toString(36).substr(2, 9);

		let contactImageTemplate = jQuery('.contact-image-template').html();
		let $contactImage = jQuery('<div class="contact-image" data-image-key="' + imageKey + '">' + contactImageTemplate + '</div>').appendTo('#contact_form .contact-images');

		image.onload = () => {
			this.log('Image loaded.');
			var canvas = $contactImage.find('canvas')[0];
			var width = image.width;
			var height = image.height;
			var shouldResize = (width > ContactFormManager.width) || (height > ContactFormManager.height);
			var context = canvas.getContext('2d');

			context.clearRect(0, 0, canvas.width, canvas.height);

			if (!shouldResize) {
				canvas.width = image.width;
				canvas.height = image.height;
				canvas.style.display = "block";
				context.drawImage(image, 0, 0, image.width, image.height);
			} else {
				let newWidth, newHeight;

				if (width > height) {
					newHeight = height * (ContactFormManager.width / width);
					newWidth = ContactFormManager.width;
				} else {
					newWidth = width * (ContactFormManager.height / height);
					newHeight = ContactFormManager.height;
				}

				canvas.width = newWidth;
				canvas.height = newHeight;
				canvas.style.display = "block";
				context.drawImage(image, 0, 0, newWidth, newHeight);
			}

			let dataUrl = canvas.toDataURL('image/jpeg', 0.6);
			let $inputElement = jQuery('<input type="hidden" name="' + imageKey + '">').val(dataUrl).appendTo('#contact_form');

			if (jQuery('#contact_form .contact-images > div').length > 0) {
				jQuery('#contact_form .contact-images').show();
			}

			this.uploadedImages[imageKey] = {
				dataUrl: dataUrl,
				inputElement: $inputElement,
				previewElement: $contactImage
			};
			this.log('Image processed and added to form.');
			this.log('Uploaded images:', this.uploadedImages);

			// Clear the file input element
			jQuery('#contact_image').val('');
		};

		image.onerror = () => {
			alert('There was an error processing your file!');
		};

		image.src = dataURL;
	}
}

const contactFormManager = new ContactFormManager(false);

function sendContactForm(token) {
	jQuery('#contact_form').get(0).submit();
}
